import React, { useContext } from 'react';
import AppContext from 'app/AppContext';
import { usePointedTime } from 'utils/components/TimeSeriesChart/timepoint';
import {
    FillsGraphData,
    getPnlLegendData,
} from 'widgets/fillsGraph/fillsGraphData';
import { FillsChartType } from 'widgets/fillsGraph/store/configuration/FillsGraphConfiguration';
import FillsChartToggleLegend from '../legend/FillsChartToggleLegend';

import PLHelp from './help/PLHelp';
import {
    realizedProfitAndLossTooltip,
    totalProfitAndLoss,
    unrealizedProfitAndLossTooltip,
} from './help/plLegendTooltip';
import { CollapseCompanionChartToggleButton } from 'widgets/fillsGraph/collapsableCompanionCharts/CollapseCompanionChartToggleButton';
import {
    getPnLLegendLabelByBenchmark,
    PnlBenchmark,
    totalPnLLabel,
} from 'utils/PnL';
import { FillsGraphPortfolioData } from 'widgets/fillsGraph/fillsGraphPortfolioData';
import { useLegendStatus } from 'widgets/fillsGraph/legendStatus';
import { FillsGraphPlChartItem } from 'widgets/fillsGraph/pl/fillsGraphPlData';

interface PLChartLegendProps {
    fillsGraphData: FillsGraphData;
    plData: FillsGraphPlChartItem[];
    fillsGraphPortfolioData: FillsGraphPortfolioData;
    pnlChartBenchmark: PnlBenchmark;
    fillsGraphContainerLeft: number;
}

export default function PLChartLegend({
    fillsGraphData,
    plData,
    fillsGraphPortfolioData,
    pnlChartBenchmark,
    fillsGraphContainerLeft,
}: PLChartLegendProps) {
    const time = usePointedTime('PLChartLegend');
    const { numberFormat } = useContext(AppContext);

    const { realized, unrealized, total } = getPnlLegendData(
        plData,
        numberFormat,
        time
    );

    const { allPlChartHidden: allHidden } = useLegendStatus(
        fillsGraphData,
        fillsGraphPortfolioData
    );

    if (allHidden) {
        return <></>;
    }

    return (
        <div className="PLChartLegend">
            <FillsChartToggleLegend
                className="realized-pl"
                label={getPnLLegendLabelByBenchmark(
                    'realized',
                    pnlChartBenchmark
                )}
                twoColourBorder={true}
                value={realized}
                fillsGraphContainerLeft={fillsGraphContainerLeft}
                chart={FillsChartType.PnL}
                property="displayRealizedPnL"
                hideLegendProperty="hideRealizedPnLLegend"
                tooltip={realizedProfitAndLossTooltip}
            />
            <FillsChartToggleLegend
                className="unrealized-pl"
                label={getPnLLegendLabelByBenchmark(
                    'unrealized',
                    pnlChartBenchmark
                )}
                twoColourBorder={false}
                value={unrealized}
                fillsGraphContainerLeft={fillsGraphContainerLeft}
                chart={FillsChartType.PnL}
                property="displayUnrealizedPnL"
                hideLegendProperty="hideUnrealizedPnLLegend"
                tooltip={unrealizedProfitAndLossTooltip}
            />
            <FillsChartToggleLegend
                className="total-pl"
                label={totalPnLLabel}
                value={total}
                fillsGraphContainerLeft={fillsGraphContainerLeft}
                chart={FillsChartType.PnL}
                property="displayTotalPnL"
                hideLegendProperty="hideTotalPnLLegend"
                tooltip={totalProfitAndLoss}
            />
            <PLHelp />
            <CollapseCompanionChartToggleButton section={FillsChartType.PnL} />
        </div>
    );
}
